import CryptoJS from "crypto-js";
import moment from "moment";
import { ELocalKey, PROD_SITE } from "./constant";

// let abortController = new AbortController();

const KEY = "SWRUSnEwSGtscHVJNm11OGlCJU9PQCF2ZF40SyZ1WFc=";
const IV = "JDB2QGtySDdWMg==";
const SIGN_KEY = "JkI2OG1AJXpnMzJfJXUqdkhVbEU0V2tTJjFKNiUleG1VQGZO";
const SUFFIX = "kRy1zN";
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const base64encoder = (t) => {
  const e = CryptoJS.enc.Utf8.parse(t);
  return CryptoJS.enc.Base64.stringify(e);
};

export const base64decoder = (Context) => {
  let tmp = CryptoJS.enc.Base64.parse(Context); // encryptedWord via Base64.parse()
  return CryptoJS.enc.Utf8.stringify(tmp);
};

export const base64Sign = (data) => {
  data = objKeySort(data);
  let pre_sign = "";
  for (let i in data) {
    pre_sign += i + "=" + data[i] + "&";
  }
  let key = base64decoder(SIGN_KEY);
  pre_sign += key;
  return CryptoJS.MD5(pre_sign).toString();
};

export const objKeySort = (arys) => {
  let newObj = {};
  let newkey = Object.keys(arys).sort();
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = arys[newkey[i]];
  }
  return newObj;
};

export const encrypt = (data, suffix = SUFFIX) => {
  let new_key = base64decoder(KEY);
  let new_iv = base64decoder(IV);

  new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
  new_key = CryptoJS.enc.Utf8.parse(new_key);

  let encrypted = CryptoJS.AES.encrypt(data, new_key, {
    iv: new_iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    formatter: CryptoJS.format.OpenSSL,
  });
  return encrypted.toString();
};

export const decrypt = (data, suffix = SUFFIX) => {
  let new_key = base64decoder(KEY);
  let new_iv = base64decoder(IV);
  new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
  new_key = CryptoJS.enc.Utf8.parse(new_key);
  let decrypted = CryptoJS.AES.decrypt(data, new_key, {
    iv: new_iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    formatter: CryptoJS.format.OpenSSL,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const isMobile = () => {
  return window.matchMedia("only screen and (max-width: 700px)").matches;
};

export const getLocalData = (key) => {
  try {
    const __data = localStorage.getItem(key);
    let val = JSON.parse(decrypt(__data));
    return val;
  } catch (error) {
    return {};
  }
};

export const fetchData = async (url) => {

  try {
    const response = await fetch(url);
    const data = await response.text();
    return data;

  } catch {
    return "";
  }
};

export const imgDecrypt = (data) => {
  try {
    const asc_key = "jeH3O1VX";
    const base_lv = "nHnsU4cX";
    const tmpiv = CryptoJS.enc.Utf8.parse(base_lv);
    const keyHex = CryptoJS.enc.Utf8.parse(asc_key);
    const decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(data),
      },
      keyHex,
      {
        iv: tmpiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        formatter: CryptoJS.format.OpenSSL,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};

export const toFmt = function (t) {
  return t ? moment(t).format("YYYY-MM-DD") : t;
};

export const fmtDateSince = (date) => {
  let seconds = Math.floor((+new Date() - +new Date(date)) / 1000)

  let interval = seconds / 31536000
  // years
  if (interval > 1) {
    return moment(date).format('YYYY-MM-DD')
  }
  // months
  interval = seconds / 2592000
  if (interval > 1) {
  //   return moment(date).format('YYYY-MM-DD')
      return Math.floor(interval) + ' 个月前'
  }

  // days
  interval = seconds / 86400
  // if (interval > 7) {
  //   return moment(date).format('YYYY-MM-DD')
  // }
  // if (interval > 1 && interval <= 7) {
  if (interval > 1) {
    return Math.floor(interval) + ' 天前'
  }
  // hours
  interval = seconds / 3600
  if (interval > 1) {
    return Math.floor(interval) + ' 小时前'
  }
  // minutes
  interval = seconds / 60
  if (interval > 1) {
    return Math.floor(interval) + ' 分钟前'
  }
  //seconds
  return Math.floor(seconds) + ' 秒'
}

export const getGB = function (value) {
  var gb = value / (1024 * 1024 * 1024);

  return gb > 0 ? (gb.toFixed(2) + "GB") : "";
};

export const secondsTimeFormat = function (duration) {
  const minutes = Math.floor(duration / 60);
  const seconds = duration - minutes * 60;
  let ret = "";
  ret += "" + (minutes > 0 ? minutes : "0") + (seconds > 0 ? "." : "") + (seconds > 0 ? (seconds < 10 ? "0" + seconds : seconds) : "");

  return ret > 0 ? ret + "分钟": "-";
}

export const getStatsParams = (
  isTop,
  channel,
  name,
  currentUrl,
  isyq,
  isMobYq
) => {
  // currentUrl 广告mapping
  const adsMapping = {
    tese: 101,
    index: 99, // home
    main: 99,
    vip: 10,
    shipin: 20,
    cili: 30,
    tupian: 40,
    meinv: 50, // lulutuqu
    xiaoshuo: 60,
    yousheng: 70,
    "app-down": 99,
    news: 99,
    // 以下不是channel 统一处理
    猫咪头条: 81,
    // "91大神网": 82,
    直播视频: 82,
    女优大全: 83,
    麻豆系列: 84,
    P站高清: 85,
    成人论坛: 86,
    海角社区: 87,
    G友原创: 88,
  };

  const defaultParams = {
    category: isTop ? "top" : channel,
    device: this.getDeviceType(),
    domain: window.location.host,
    site: `${PROD_SITE}_1`,
    system: this.isMobile() ? 2 : 1,
    timestamp: moment().valueOf(),
  };
  if (name) {
    defaultParams["name"] = name;
  }
  if (currentUrl) {
    let _selected = "";
    let _channel = "";
    for (let i in adsMapping) {
      if (currentUrl.indexOf(i) >= 0) {
        _selected = adsMapping[i];
        _channel = i === "main" ? "index" : i;
        break;
      }
    }
    defaultParams["c"] = _selected;
    defaultParams["category"] = isTop ? "top" : _channel;

    if (_selected >= 81 && _selected <= 88 && !isTop) {
      defaultParams["category"] = "tesezhuanqu";
    }
    if (isTop) delete defaultParams["channel"];
  }
  if (isyq) {
    defaultParams["c"] = 98;
  }
  if (isMobYq) {
    defaultParams["category"] = "youqingtuijian";
    delete defaultParams["c"];
  }
  return defaultParams;
};

export const formLogin = (str) => {
  const _baseData = getLocalData(ELocalKey._BASE);
  let _vip = _baseData?.vip_domain;
  
  if (_vip && _vip.slice(-1) === '/') {
      _vip = _baseData.slice(0, -1);
  }
  // const isTrue = true; //process.env.NODE_ENV !== 'production';
  // _vip = isTrue ? "/login" : `${_vip}/user/login.html`;

  if (str) {
      return _vip
  }


  return window.open(_vip)
}

export const kefuOpen = () => {
  let _url = formLogin(true);
  const val = getLocalData(ELocalKey._BASE)?.customer_service_url;
  if (val) {
      return window.open(val, '_blank')
  }
  // if (this.isLogin()) {
  //     let __data = localStorage.getItem(ELocalKey._USER);
  //     try {
  //         __data = JSON.parse(decrypt(__data))
  //     } catch {
  //         window.open(_url)    
  //     }
  //     window.open(__data?.custom_url || _url)
  // }
  return window.open(_url, '_blank')
}

export const tgOpen = () => {
  const val = getLocalData(ELocalKey._BASE)?.contact_telegram;
  if (val) {
      return window.open(val, '_blank')
  }
  return;
}

export const clearExpireLocalStorage = () => {
  let hours = 1;
  let now = Date.now();
  let setupTime = localStorage.getItem('setupTimeCili');
  if (setupTime == null) {
      localStorage.setItem('setupTimeCili', now.toString())
  } else if ((now - parseInt(setupTime)) > hours*60*60*1000) {
      localStorage.clear()
      localStorage.setItem('setupTimeCili', now.toString());
  }
}

export const randomNumberInRange = (min, max) =>{
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const documentWriteStatisticsScript = (domain = "https://sta.zuhuaizhijia.com") => {
  let hm = document.createElement("script");
  hm.innerHTML = `!function(){"use strict";!function(t){var e=t.screen,n=e.width,r=e.height,a=t.navigator.language,i=t.location,o=t.localStorage,u=t.document,c=t.history,f=i.hostname,s=i.pathname,l=i.search,d=u.currentScript;if(d){var m="data-",h=d.getAttribute.bind(d),v=(h(m+"host-url"),"false"!==h(m+"auto-track")),p=h(m+"do-not-track"),g=h(m+"domains")||"",b=g.split(",").map((function(t){return t.trim()})),y=n+"x"+r,S=/data-umami-event-([\\w-_]+)/,k=m+"umami-event",j=function(t,e,n){var r=t[e];return function(){for(var e=[],a=arguments.length;a--;)e[a]=arguments[a];return n.apply(null,e),r.apply(t,e)}},w=function(){return{website:"af9a3624-d08c-4b13-b7c5-1b79c2236e89",hostname:f,screen:y,language:a,title:q,url:P,referrer:document.referrer}},N=function(){return o&&o.getItem("umami.disabled")||p&&function(){var e=t.doNotTrack,n=t.navigator,r=t.external,a="msTrackingProtectionEnabled",i=e||n.doNotTrack||n.msDoNotTrack||r&&a in r&&r[a]();return"1"==i||"yes"===i}()||g&&!b.includes(f)},T=function(t,e,n){n&&(_=P,(P=function(t){try{return new URL(t).pathname}catch(e){return t}}(n.toString()))!==_&&setTimeout(x,300))},A=function(t,e){if(void 0===e&&(e="event"),!N()){var n={"Content-Type":"application/json"};return void 0!==E&&(n["x-umami-cache"]=E),fetch("${domain}/api/send",{method:"POST",body:JSON.stringify({type:e,payload:t}),headers:n}).then((function(t){return t.text()})).then((function(t){return E=t})).catch((function(){}))}},x=function(t,e){return A("string"==typeof t?Object.assign({},w(),{name:t,data:"object"==typeof e?e:void 0}):"object"==typeof t?t:"function"==typeof t?t(w()):w())};t.umami||(t.umami={track:x,identify:function(t){return A(Object.assign({},w(),{data:t}),"identify")}});var E,O,L,D,K,P=""+s+l,_=u.referrer,q=u.title;if(v&&!N()){c.pushState=j(c,"pushState",T),c.replaceState=j(c,"replaceState",T),K=function(t){var e=t.getAttribute.bind(t),n=e(k);if(n){var r={};return t.getAttributeNames().forEach((function(t){var n=t.match(S);n&&(r[n[1]]=e(t))})),x(n,r)}return Promise.resolve()},u.addEventListener("click",(function(t){var e=t.target,n="A"===e.tagName?e:function(t,e){for(var n=t,r=0;r<10;r++){if("A"===n.tagName)return n;if(!(n=n.parentElement))return null}return null}(e);if(n){var r=n.href,a="_blank"===n.target||t.ctrlKey||t.shiftKey||t.metaKey||t.button&&1===t.button;if(n.getAttribute(k)&&r)return a||t.preventDefault(),K(n).then((function(){a||(i.href=r)}))}else K(e)}),!0),L=new MutationObserver((function(t){var e=t[0];q=e&&e.target?e.target.text:void 0})),(D=u.querySelector("head > title"))&&L.observe(D,{subtree:!0,characterData:!0,childList:!0});var C=function(){"complete"!==u.readyState||O||(x(),O=!0)};u.addEventListener("readystatechange",C,!0),C()}}}(window)}();`;
  let s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
}

export const documentInsertStatisticsScript = (domain = "https://sta.zuhuaizhijia.com") => {
  localStorage.setItem('statistics_domain',domain);
  let hm = document.createElement("script");
  hm.src = './statistics-script.js';
  hm.async = true;
  let s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
}

export const addImgKeyParam = function (url) {
  let secret_key = SECRET_KEY;
  let currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  let storedTime = sessionStorage.getItem('timestamp'); // Get the stored timestamp from sessionStorage

  let time; // Declare the time variable

  // If there is a stored time and 5 minutes haven't passed, reuse the stored time
  if (storedTime && currentTime - parseInt(storedTime) < 300) {
      time = parseInt(storedTime) + 300; // Use the stored timestamp and add 300 seconds
  } else {
      // If no stored time or more than 5 minutes have passed, generate a new timestamp
      time = currentTime + 300; // Add 300 seconds to the current time
      sessionStorage.setItem('timestamp', currentTime.toString()); // Store the new timestamp in sessionStorage
  }

  // let hexTime = time.toString(16); // 转换为十六进制字符串
  // let uri = "/xmmvip/xmmvip/e73172371207066dc2d5ad72f2__289916/e73172371207066dc2d5ad72f2__289916_thumb_5903.jpg"
  let uri = url;

  let paramToAppend = secret_key + uri + time; // 确保这里是十六进制
  
  let key = CryptoJS.MD5(paramToAppend).toString(); // 使用CryptoJS计算MD5

  return '?wsSecret=' + key + "&wsTime=" + time; // 使用十六进制时间戳
}